import {
  AutoBonusPeriodResponse,
  AutoBonusPeriodsPageResponse,
} from "../../../domain/models/integration/auto-bonus-periods.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);
const isString = (value: unknown): value is string => typeof value === "string";
const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isPeriod = (value: unknown): value is AutoBonusPeriodResponse =>
  isRecord(value) &&
  isString(value["periodStart"]) &&
  isString(value["periodEnd"]) &&
  isString(value["paymentDate"]) &&
  isNumber(value["amountToPay"]) &&
  isNumber(value["paidAmount"]) &&
  isNumber(value["difference"]) &&
  isNumber(value["paymentCount"]) &&
  isNumber(value["paidCount"]) &&
  (value["status"] === "PENDING" ||
    value["status"] === "PARTIALLY_PAID" ||
    value["status"] === "PAID") &&
  isNumber(value["previousMonthCarryover"]) &&
  isString(value["currency"]);

export function isAutoBonusPeriodsPageResponse(
  value: unknown,
): value is AutoBonusPeriodsPageResponse {
  return isRecord(value) &&
    Array.isArray(value["content"]) &&
    value["content"].every(isPeriod) &&
    isNumber(value["page"]) &&
    isNumber(value["size"]) &&
    isNumber(value["totalElements"]) &&
    isNumber(value["totalPages"]);
}
